import { walletAddressAtom } from '../wallet';
import { activeAccountIdAtom } from './activeAccountIdAtom';
import { getAccountAddressFromId } from '../../utils';
import storage from '../../storage';
import { createAsyncAtom } from '../../lib/state';

const lendAndBorrowTransactionHistoryAtom = createAsyncAtom(async get => {
  const walletAddress = await get(walletAddressAtom);
  const activeAccountId = await get(activeAccountIdAtom);

  if (!walletAddress) {
    return null;
  }

  const accountAddress = getAccountAddressFromId(walletAddress, activeAccountId);

  const transactions = await storage.getTransactionHistory(accountAddress);

  return transactions;
});
export default lendAndBorrowTransactionHistoryAtom;
